import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { Toaster } from "@/components/ui/sonner";
import Login from "@/pages/Login";
import Layout from "@/components/Layout";
import Dashboard from "@/pages/Dashboard";
import Expenses from "@/pages/Expenses";
import Caixa from "@/pages/Caixa";
import Pagamentos from "@/pages/Pagamentos";
import Contratos from "@/pages/Contratos";
import Clientes from "@/pages/Clientes";
import Forecast from "@/pages/Forecast";
import Admin from "@/pages/Admin";
import { Loader2 } from "lucide-react";

function Protected({ children, adminOnly }) {
  const { user, loading } = useAuth();
  if (loading || user === null)
    return <div className="min-h-screen flex items-center justify-center"><Loader2 className="h-6 w-6 animate-spin text-primary" /></div>;
  if (!user) return <Navigate to="/login" replace />;
  if (adminOnly && user.role !== "admin") return <Navigate to="/" replace />;
  return <Layout>{children}</Layout>;
}

function AppRoutes() {
  const { user, loading } = useAuth();
  return (
    <Routes>
      <Route path="/login" element={loading ? null : user ? <Navigate to="/" replace /> : <Login />} />
      <Route path="/" element={<Protected><Dashboard /></Protected>} />
      <Route path="/despesas" element={<Protected><Expenses /></Protected>} />
      <Route path="/pagamentos" element={<Protected><Pagamentos /></Protected>} />
      <Route path="/contratos" element={<Protected><Contratos /></Protected>} />
      <Route path="/clientes" element={<Protected><Clientes /></Protected>} />
      <Route path="/caixa" element={<Protected><Caixa /></Protected>} />
      <Route path="/previsoes" element={<Protected><Forecast /></Protected>} />
      <Route path="/admin" element={<Protected adminOnly><Admin /></Protected>} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <AppRoutes />
          <Toaster position="top-right" richColors />
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
